import {
  DeleteNotificationSegment,
  DeleteNotificationSegmentVariables
} from './__generated__/DeleteNotificationSegment'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteNotificationSegment($input: DeleteNotificationSegmentInputV2!) {
    deleteNotificationSegment: deleteNotificationSegmentV2(input: $input) {
      ... on NotificationSegmentV2 {
        id
        title
      }
    }
  }
`

export const useDeleteNotificationSegment = () =>
  useMutation<DeleteNotificationSegment, DeleteNotificationSegmentVariables>(MUTATION)
